<!--163번 템플릿에서 사용됨-->
<template>
  <div class="mt-component-form">
    <!-- pc  -->
    <div class="hidden xl:block ">
      <vs-row class="my-4 center-flex">
        <h5><i class="dot"></i>{{ this.title }}</h5>
        <div class="ml-auto">
          <vs-button
            v-if="!isPrint && !isReadonly"
            class=""
            color="secondary"
            type="border"
            @click="handleAddRow"
          >{{ $t('항목추가') }}</vs-button
          >
          <vs-button
            v-if="!isPrint && !isReadonly"
            class="ml-4"
            color="secondary"
            @click="handleRemoveRow"
          >{{ $t('선택삭제') }}</vs-button
          >
        </div>
      </vs-row>
      <div
        class="grid row-header"
        :class="[isPrint || isReadonly? ' grid-cols-10' : ' grid-cols-11']"
      >
        <div v-if="!isPrint && !isReadonly" class="col-span-1 row-header__item">
          <vs-checkbox
            v-model="equipAllCheck"
            @change="changeAllCheck"
          ></vs-checkbox>
        </div>
        <div class="col-span-2 row-header__item">{{ $t('점검장소') }}</div>
        <div class="col-span-2 row-header__item">{{ $t('업체명') }}</div>
        <div class="col-span-2 row-header__item">{{ $t('주요작업') }}</div>
        <div class="col-span-2 row-header__item">{{ $t('점검내용') }}</div>
        <div class="col-span-2 row-header__item">{{ $t('재해형태') }}</div>
      </div>
      <!-- rows -->
      <div
        class="grid row-content"
        :class="[isPrint || isReadonly ? ' grid-cols-10' : ' grid-cols-11']"
        v-for="(rows, rowIndex) in equipmentList"
        :key="rowIndex"
      >
        <div v-if="!isPrint && !isReadonly" class="col-span-1 none-border-center">
          <vs-checkbox v-model="rows.is_checked"></vs-checkbox>
        </div>
        <div class="col-span-2 item-area textarea-container">
          <ml-input
            v-if="!isPrint"
            rows="1"
            v-model="rows.name"
            class="w-full flex-1 p-1"
            placeholder="입력"
            :readonly="isReadonly"
          />
          <span v-else class="print-input"> {{ rows.name }}</span>
        </div>
        <div class="col-span-2 item-area textarea-container">
          <!--        <CompanySelector-->
          <!--          v-if="!isPrint"-->
          <!--          v-model="rows.company"-->
          <!--          class="w-full flex-1"-->
          <!--          :readonly="isReadonly"-->
          <!--        />-->
          <ml-input
            v-if="!isPrint"
            rows="1"
            v-model="rows.company"
            class="w-full flex-1 p-1"
            placeholder="입력"
            :readonly="isReadonly"
          />
          <span v-else class="print-input">{{ rows.company }}</span>
        </div>
        <div class="col-span-2 item-area textarea-container">
          <ml-textarea
            v-if="!isPrint"
            height="90px"
            v-model="rows.primary"
            class="w-full flex-1 p-1 resize-stop"
            placeholder="입력"
            :readonly="isReadonly"
          />
          <span v-else class="print-textarea">{{ rows.primary }}</span>
        </div>
        <div class="col-span-2 item-area textarea-container">
          <ml-textarea
            v-if="!isPrint"
            height="90px"
            v-model="rows.body"
            class="w-full flex-1 p-1 resize-stop"
            placeholder="입력"
            :readonly="isReadonly"
          />
          <span v-else class="print-textarea">{{ rows.body }}</span>
        </div>
        <div class="col-span-2 item-area textarea-container" :style="{color: disasterColor}">
          <DisasterClassSelector
            v-if="!isPrint"
            class="w-full"
            v-model="rows.disaster"
            :readonly="isReadonly"
            @input="updateList"
          />
          <span v-else class="print-input">{{ rows.disaster }}</span>
        </div>
      </div>
    </div>

    <!-- mobile -->
    <div class="block xl:hidden">
      <h5 class="mb-4"><i class="dot"></i>{{ this.title }}</h5>

      <!-- rows -->
      <div v-for="(rows, rowIndex) in equipmentList" :key="rowIndex" class="mb-4" style="border: 1px solid #cdcdcd; ">
        <div class="p-2 flex border-bottom" style="background-color: #efefef">
          <span class="flex-1" style="font-size: 14px; font-weight: 500">{{ itemTitle ? `${itemTitle} `: ''}}#{{ rowIndex }}</span>
          <span style="color:#EA5455;" @click="handleRemoveRow(rowIndex)">{{ $t('삭제') }}</span>
        </div>
        <div class="p-2 border-bottom">
          <div class="mb-2" style="font-size: 14px; font-weight: 500">{{ $t('점검장소') }}</div>
          <div>
            <ml-input
              v-model="rows.name"
              class="w-full flex-1 p-1"
              placeholder="입력"
              :readonly="isReadonly"
            />
          </div>
        </div>
        <div class="p-2 border-bottom">
          <div class="mb-2" style="font-size: 14px; font-weight: 500">{{ $t('업체명') }}</div>
          <div>
            <ml-input
              rows="1"
              v-model="rows.company"
              class="w-full flex-1 p-1"
              placeholder="입력"
              :readonly="isReadonly"
            />
          </div>
        </div>
        <div class="p-2 border-bottom">
          <div class="mb-2" style="font-size: 14px; font-weight: 500">{{ $t('주요작업') }}</div>
          <div>
            <ml-textarea
              height="90px"
              v-model="rows.primary"
              class="w-full flex-1 p-1 resize-stop"
              placeholder="입력"
              :readonly="isReadonly"
            />
          </div>
        </div>
        <div class="p-2 border-bottom">
          <div class="mb-2" style="font-size: 14px; font-weight: 500">{{ $t('점검내용') }}</div>
          <div>
            <ml-textarea
              height="90px"
              v-model="rows.body"
              class="w-full flex-1 p-1 resize-stop"
              placeholder="입력"
              :readonly="isReadonly"
            />
          </div>
        </div>
        <div class="p-2">
          <div class="mb-2" style="font-size: 14px; font-weight: 500">{{ $t('재해형태') }}</div>
          <div>
            <DisasterClassSelector
              class="w-full"
              v-model="rows.disaster"
              :readonly="isReadonly"
              @input="updateList"
            />
          </div>
        </div>
      </div>

      <div v-if="equipmentList.length === 0" style="min-height: 120px; display: flex; justify-content: center; align-items: center; border: 1px solid #cdcdcd; ">
        <p class="s-text">{{ $t('등록된 항목이 없습니다.') }}</p>
      </div>

      <!-- add button -->
      <div class="w-full mt-6 flex justify-center">
        <vs-button
          v-if="!isPrint && !isReadonly"
          class="w-1/2"
          color="#7E72F2"
          style="min-width: 120px; color: #fff;"
          @click="handleAddRow"
        >{{ $t('항목추가') }}</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import CompanySelector from "@/components/selector/CompanySelector";
export default {
  name: "InspectionInfoList",
  components: { CompanySelector, DisasterClassSelector },
  props: {
    title: String,
    itemTitle: String,
    list: Array,
    isPrint: Boolean,
    isReadonly: Boolean,
    disasterColor: {
      type: String,
      default: '#3c3c3c'
    },
  },
  watch: {
    list: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value && value.length > 0) {
          this.equipmentList = value;
        }
      },
    },
  },
  methods: {
    checkForm(value, rowIndex, text) {
      if (value.target.checked) {
        this.$emit("update-list-check", rowIndex - 1, text);
      } else {
        this.$emit("update-list-check", rowIndex - 1, "");
      }
    },
    // 항목추가
    handleAddRow() {
      this.equipmentList.push({
        is_checked: this.equipAllCheck,
        name: "",
        manufacturer: "",
        standard: "",
      });
      this.updateList();
    },
    // 선택삭제
    handleRemoveRow(rowIndex) {

      if (typeof rowIndex === 'number') {
        this.equipmentList.splice(rowIndex, 1);

      } else {

        for (let i = 0; i < this.equipmentList.length; i++) {
          if (this.equipmentList[i].is_checked) {
            this.equipmentList.remove(this.equipmentList[i]);
            i = -1;
          }
        }
        this.equipAllCheck = false;
      }


      this.updateList();
    },
    // 일괄 체크
    changeAllCheck() {
      for (const data of this.equipmentList) {
        data.is_checked = this.equipAllCheck;
      }
    },
    // update
    updateList() {
      this.$emit("updateList", this.equipmentList);
    },
  },
  data() {
    return {
      equipAllCheck: false,
      equipmentList: [],
    };
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$bg: #f9f9f9;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.label-text {
  width: 127px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 25px;
}
.vs-checkbox-default {
  margin: 0;
}
.ml-group-checkBox ~ .ml-group-checkBox {
  margin: 0;
}

/* Table */
.row-header {
  background-color: $bg;
  text-align: center;

  &__checkbox-title {
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: $border;
    width: 100%;
  }
  &__checkboxs {
    display: flex;
    height: 50%;
    width: 100%;
    div {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    div:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
}
.row-header__item {
  border-top: $border;
  border-bottom: $border;
  border-left: none;
  border-right: none;
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.row-header__item.item-col {
  flex-direction: column;
}
.row-header__item:last-child {
  border-right: none;
}

.none-border-center {
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* row data */
.row-content {
  border-bottom: $border;
  &__title {
    background-color: $bg;
    height: 100%;
  }
  &__body {
  }
}
.row-content__body-item {
  .item-content {
    padding: 15px;
    border-left: $border;

    pre {
      font-family: "Noto Sans KR", "Montserrat", Helvetica, Arial, sans-serif;
      white-space: pre-wrap;
    }
  }
  .item-box {
    border-left: $border;
    border-right: $border;
    display: flex;
    .item-box-check {
      flex: 1;
      justify-content: center !important;
    }
    .item-box-check:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
  .item-area {
    padding: 5px;
    align-self: center;
  }
}
.row-content__body-item ~ .row-content__body-item {
  border-top: $border;
}
.vs-component.vs-con-textarea.vs-textarea-primary {
  margin: 0;
}
.row-content-none-data {
  height: 120px;
  border-bottom: $border;
  display: flex;
  justify-content: center;
  align-items: center;
}
.textarea-container {
  padding: 0.25rem !important;
}
.resize-stop textarea {
  resize: none !important;
}
</style>
